import { useState } from 'react'
import { Box, MenuItem, Menu } from '@mui/material'

import { dropDownMenuStyles as styles } from 'src/components/shared/DropDownMenu/DropDownMenuStyle'

type DropDownMenuItemType = {
  title: string
  onClick: () => void
  disabled?: boolean
}

type DropDownMenuPropsType = {
  id: string
  title: string
  items: DropDownMenuItemType[]
}

export default function DropDownMenu({ id, title, items }: DropDownMenuPropsType): JSX.Element {
  const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null)
  const openMenu = Boolean(anchorEl)

  return (
    <>
      <Box onClick={ev => setAnchorEl(ev.currentTarget)} sx={styles.menuButton}>
        <Box component="span" sx={styles.menuButtonText}>
          {title}
        </Box>
      </Box>
      <Menu
        id={`menu_${id}`}
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        open={openMenu}
        onClose={() => setAnchorEl(null)}
        sx={styles.menu}
      >
        {items.map(element => (
          <MenuItem
            key={`menu_item_${element.title}`}
            sx={styles.menuItem}
            onClick={() => {
              element.onClick()
              setAnchorEl(null)
            }}
            disabled={element?.disabled}
          >
            {element.title}
          </MenuItem>
        ))}
      </Menu>
    </>
  )
}
